import { useEffect, useState } from "react";
import { TCategorizedAgenda } from "../../../organisms/accept-invitation-form/type";
import { getPeAgenda } from "../../../organisms/accept-invitation-form/helper";

// Custom hooks
const useAgendaData = ( peId: string, projectId: string, agendaId?: string ) => {
  const [peAgendaData, setPeAgendaData] = useState<TCategorizedAgenda>({
    sentAgenda: [],
    respondedByAdminAgenda: [],
    respondedByExpertAgenda: [],
    declineAgenda: [],
  });
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      await getPeAgenda({
        fk_project: +projectId,
        fk_pe: +peId,
        setPeAgendaData,
        fk_agenda: agendaId ? +agendaId : undefined
      });
      setLoading(false);
    };
    getData();
  }, [agendaId, peId, projectId]);

  return { peAgendaData, setPeAgendaData, loading, setLoading };
};

export default useAgendaData;